import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledBidsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  ${pickThemeFontStyles('28', '32', 'SEMI_BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
  margin: 0;

  svg {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

export const StyledHeaderCount = styled.span`
  ${pickThemeFontStyles('24', '32', 'SEMI_BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;
